import { safeDecodeURIComponent } from './url';

/**
 * 解析文档中的所有 cookies，并将它们作为对象返回。
 * @returns {Record<string, string>} 一个对象，映射了 cookie 名称到它们的值。
 */
export const getAllCookies = (): Record<string, string> => {
    return document.cookie.split('; ').reduce((cookies, cookie) => {
        const [name, value] = cookie.split('=');

        cookies[name] = safeDecodeURIComponent(value || '');

        return cookies;
    }, {} as Record<string, string>);
};

/**
 * 通过名称检索特定的 cookie 值。
 * @param {string} key 要检索的 cookie 的名称。
 * @returns {string} cookie 的值，如果未找到则为空字符串。
 */
export const getCookie = (key: string): string => {
    const cookies = getAllCookies();

    return cookies[key] || '';
};